export default "/react/logoRoistat-2321b5b0.png";